import Stylus from './Stylus';
import DeviceDrawingBrush from './DeviceDrawingBrush';
import phone from '../assets/icons/devicePhone.svg';
import tablet from '../assets/icons/deviceTablet.svg';
import browser from '../assets/icons/deviceBrowser.svg';
import laptop from '../assets/icons/deviceLaptop.svg';
import { svgToIcon } from '../utils/svg';
import styles from '../styles.module.css';
import { labeledMenuComponent } from '../utils/stylus';
import { startCase } from 'lodash';

const DEVICE_ICONS = {
  phone,
  tablet,
  browser,
  laptop,
};
// Create new frame objects.
class StylusDevice extends Stylus {
  deviceName: string;
  deviceClass: any;

  constructor({ controller, deviceName }) {
    super({ controller });
    this.deviceName = deviceName;
  }

  stylusId() {
    return this.deviceName;
  }

  toolButtonClass() {
    return styles.labeledToolButton;
  }

  renderIcon() {
    return svgToIcon(DEVICE_ICONS[this.deviceName]);
  }

  menuComponent() {
    return labeledMenuComponent(this.renderIcon(), this.description());
  }

  description() {
    return startCase(this.deviceName);
  }

  activate() {
    const brush = new DeviceDrawingBrush(this.controller.canvas, this, {
      deviceName: this.deviceName,
    });
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  cursor() {
    return 'crosshair';
  }
}

export default StylusDevice;
